import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Stack,
  Typography,
} from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import CourseDisplaySettingsPanel from './components/CourseDisplaySettingsPanel';

/**
 * Dedicated page for course thumbnail + enrollment visibility.
 * Path: /dashboard/students/courses/:courseId/display-settings
 */
const CourseDisplaySettingsPage = () => {
  const { courseId } = useParams();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        py: { xs: 2, sm: 3 },
        background: 'linear-gradient(180deg, #eef2ff 0%, #ffffff 40%)',
        minHeight: '80vh',
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={2.5}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} alignItems={{ xs: 'stretch', sm: 'center' }}>
            <Button
              startIcon={<ArrowBackRoundedIcon />}
              onClick={() => navigate('/dashboard/students/courses')}
              variant="outlined"
            >
              Back to Courses
            </Button>
            <Button
              variant="text"
              onClick={() => navigate(`/dashboard/students/courses/${courseId}/builder`)}
            >
              Open LMS Builder
            </Button>
          </Stack>

          <Box>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
              <SettingsSuggestIcon color="primary" />
              <Typography variant="h5" fontWeight={800}>
                Course Display Settings
              </Typography>
            </Stack>
            <Typography variant="body2" color="text.secondary">
              Course ID: <strong>{courseId}</strong> — set the course price, thumbnail, and enrollment count visibility for the student app.
            </Typography>
          </Box>

          <CourseDisplaySettingsPanel courseCode={courseId} />
        </Stack>
      </Container>
    </Box>
  );
};

export default CourseDisplaySettingsPage;
